import { useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { twMerge } from "tailwind-merge";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Pagination, Autoplay } from "swiper/modules";
import 'react-lazy-load-image-component/src/effects/blur.css';

// Swiper Images
import Img1 from "../../../assets/landing/imageCarouselImage1.webp";
import Img2 from "../../../assets/landing/imageCarouselImage2.webp";
import Img3 from "../../../assets/landing/imageCarouselImage3.webp";
import Img4 from "../../../assets/landing/imageCarouselImage4.webp";
import Img5 from "../../../assets/landing/imageCarouselImage5.webp";

import Img1_LQ from "../../../assets/landing/imageCarouselImage1_lq.webp";
import Img2_LQ from "../../../assets/landing/imageCarouselImage2_lq.webp";
import Img3_LQ from "../../../assets/landing/imageCarouselImage3_lq.webp";
import Img4_LQ from "../../../assets/landing/imageCarouselImage4_lq.webp";
import Img5_LQ from "../../../assets/landing/imageCarouselImage5_lq.webp";

const HeroSection = () => {

  const [loaded, setLoaded] = useState(false);

  const heroImages = [{hq: Img1, lq: Img1_LQ}, {hq: Img2, lq: Img2_LQ}, {hq: Img3, lq: Img3_LQ}, {hq: Img4, lq: Img4_LQ}, {hq: Img5, lq: Img5_LQ}];

  return (
    <div className="flex flex-col lg:flex-row items-center justify-between gap-8 w-full mb-10 px-[20px] md:px-[40px] lg:px-[100px]">
      {/* Hero Content Section */}
      <div className="flex flex-col gap-6 sm:gap-8 lg:gap-10 w-full xl:w-[527px]">
        <h1 className="font-nonito_sans font-bold text-3xl sm:text-4xl m-0 xl:text-[42px] leading-tight sm:leading-[1.2] lg:leading-[56px] text-primary-text text-center lg:text-left">
          Find Skilled Professionals for Your Jobs
        </h1>

        <p className="font-inter font-normal text-base text-content m-0 text-center lg:text-left max-w-2xl lg:max-w-none mx-auto lg:mx-0">
          Whether you need someone for a quick task or a long-term project, we
          connect you with skilled professionals who are ready to help. Post a
          job and get matched with the perfect service providers today!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-7 justify-center lg:justify-start">
          <Link
            to="/client/post-job"
            className="bg-primary flex items-center justify-center text-white font-inter font-semibold text-base w-full sm:w-[214px] h-[49px] rounded-xl hover:bg-primary/90 transition-colors"
          >
            Post a Job
          </Link>
          <Link
            to="/client/find-service-pro"
            className=" flex items-center justify-center border border-primary text-primary font-inter font-semibold text-base w-full sm:w-[214px] h-[49px] rounded-xl hover:bg-primary-light transition-colors"
          >
            Find a Service Pro
          </Link>
        </div>
      </div>

      {/* Image Slider Section */}
      <div className="w-full lg:w-1/2 mt-8 lg:mt-0">
        <Swiper
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Pagination, Autoplay]}
          className="w-full h-[300px] sm:h-[400px] lg:h-[520px] rounded-[20px] sm:rounded-[30px] lg:rounded-[40px]"
        >
          {heroImages.map((image, index) => (
            <SwiperSlide key={index}>
              <div className={twMerge("flex w-full h-[100%]", loaded ? "bg-transparent" : "bg-gray-300 animate-pulse")}>
                <LazyLoadImage
                  src={image?.hq}
                  placeholderSrc={image?.lq}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-full object-cover rounded-[20px] sm:rounded-[30px] lg:rounded-[40px]"
                  effect="blur"
                  onLoad={() => {
                    setLoaded(true);
                  }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default HeroSection;
